/**
 * Get the publicUrl.
 * This is used primarily to enable compatibility with the Sitecore Experience Editor.
 */
export const getPublicUrl = (): string => {
  return process.env.PUBLIC_URL || '';
};

export const getRecaptchaKey = (): string => {
  return process.env.NEXT_PUBLIC_GOOGLE_RECAPTCHA_KEY || '';
};

export const getGoogleAssessmentKey = (): string => {
  return process.env.NEXT_PUBLIC_GOOGLE_ASSESSMENT_KEY || '';
};

export const getImaginarysRecaptchaKey = (): string => {
  return process.env.NEXT_PUBLIC_IMAGINARYS_RECAPTCHA || '';
};

export const getEcardUrl = (): string => {
  return process.env.NEXT_PUBLIC_ECARD_URL || '';
};

export const getDeliveryUrl = (): string => {
  return process.env.NEXT_PUBLIC_DELIVERY_URL || '';
};

export const getDeliveryKey = (): string => {
  return process.env.NEXT_PUBLIC_DELIVERY_KEY || '';
};

export const getDiscoveryUrl = (): string => {
  return process.env.NEXT_PUBLIC_DISCOVERY_URL || '';
};

export const getDiscoveryKey = (): string => {
  return process.env.NEXT_PUBLIC_DISCOVERY_KEY || '';
};

export const getCancerFormUrl = (): string => {
  return process.env.NEXT_PUBLIC_CANCER_FORM_URL || '';
};

export const getProvidersSearchSrc = (): string => {
  return process.env.NEXT_PUBLIC_PROVIDERS_SRC || '';
};

export const getLocationsSearchSrc = (): string => {
  return process.env.NEXT_PUBLIC_LOCATIONS_SRC || '';
};

export const getSpecialtiesComboSearchSrc = (): string => {
  return process.env.NEXT_PUBLIC_SPECIALTIESCOMBO_SRC || '';
};

export const getOfficesSearchSrc = (): string => {
  return process.env.NEXT_PUBLIC_OFFICES_SRC || '';
};

export const getLanguagesSearchSrc = (): string => {
  return process.env.NEXT_PUBLIC_LANGUAGES_SRC || '';
};

export const getSearchWidget = (): string => {
  return process.env.NEXT_PUBLIC_WIDGET || '';
};

export const getPldFormLogicAppUrl = (): string => {
  return process.env.NEXT_PUBLIC_LOGIC_APP_URL || '';
};

type SearchResultType = 'providers' | 'locations';

type GetResultsCountTextParams = {
  count: number;
  pageSize: number;
  page: number;
  searchType: SearchResultType;
};

export const getResultsCountText = ({
  count,
  pageSize,
  page,
  searchType,
}: GetResultsCountTextParams): string => {
  const resultType = searchType === 'providers' ? 'Providers' : 'Locations';

  if (count <= 10) {
    return `Showing ${count} Total ${resultType}`;
  }

  const startResult = (page - 1) * pageSize + 1;
  const endResult = Math.min(page * pageSize, count);

  return `Showing ${startResult} - ${endResult} of ${count} ${resultType}`;
};
